/**
 * Loading screen with health-themed branding
 */
import React from 'react';

const LoadingScreen = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-primary-50 to-blue-100">
    <div className="text-center">
      <div className="w-16 h-16 mx-auto mb-4 relative">
        <div className="spinner w-16 h-16"></div>
        <span className="absolute inset-0 flex items-center justify-center text-2xl">🏥</span>
      </div>
      <h2 className="text-xl font-semibold text-primary-700 mb-2">
        Chronic Diseases Consultation
      </h2>
      <p className="text-gray-500 text-sm">Loading your healthcare portal...</p>
    </div>
  </div>
);

export default LoadingScreen;
